import React from 'react'

export const Units = [
  {
    name: 'list',
    component: React.lazy(() => import('../../../modules/admin/general-parameters/units/UnitsList')),
    path: '/admin/general-parameters/units',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() => import('../../../modules/admin/general-parameters/units/UnitsCreate')),
    path: '/admin/general-parameters/units/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() => import('../../../modules/admin/general-parameters/units/UnitsEdit')),
    path: '/admin/general-parameters/units/edit/:unitId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
